// test1260
(1260 && 0);
